import { Box } from '@factorialco/deprecated-design-system'

import { AssignmentList } from 'modules/cost_centers/components/CostCenterAssigments/components/AssignmentList'
import { CostCenterAssignment } from 'modules/cost_centers/components/CostCenterAssigments/lib/types'

import { EmptyState } from '../EmptyState'

export const CurrentAssignments = ({
  currentAssignment,
  assignments,
  canManageCostCenterEmployeesAssignments,
  onEditAssignment,
  onClickDeleteOption,
}: {
  currentAssignment: CostCenterAssignment[]
  assignments: CostCenterAssignment[]
  canManageCostCenterEmployeesAssignments: boolean
  onEditAssignment: () => void
  onClickDeleteOption: () => void
}) => {
  return (
    <Box
      border={{
        all: {
          style: 'solid',
          width: 's1',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      paddingX="s24"
      paddingY="s20"
    >
      {assignments.length > 0 ? (
        <AssignmentList
          assignments={currentAssignment ? currentAssignment : []}
          {...(canManageCostCenterEmployeesAssignments && {
            options: { onEdit: onEditAssignment, onDelete: onClickDeleteOption },
          })}
        />
      ) : (
        <EmptyState />
      )}
    </Box>
  )
}
